/* eslint-disable max-len */
import React from 'react';

export const ArrowDownIcon = () => {
    return (
        <svg width="20px" height="8px" viewBox="0 0 14 8"
            style={{ pointerEvents: 'none', position: 'absolute', right: '10px' }}>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none"
                fillRule="evenodd">
                <g id="Academic-year-01a"
                    transform="translate(-424.000000, -334.000000)">
                    <g id="Group-4"
                        transform="translate(297.000000, 292.000000)">
                        <g id="Input/Text/Default"
                            transform="translate(0.000000, 24.000000)">
                            <g id="icon/dropdown" opacity="0.600000024"
                                transform="translate(122.000000, 10.000000)"
                                fill="#000000">
                                <g id="Group"
                                    transform="translate(5.000000, 8.000000)">
                                    <g id="Group"
                                        transform="translate(0.000000, 0.888889)">
                                        <path
                                            d="M0.79325,1.50664897 C0.40225,1.16179327 0.40225,0.603497472 0.79325,0.258641774 C1.18425,-0.0862139246 1.81725,-0.0862139246 2.20825,0.258641774 L7.86425,5.24890659 C8.25425,5.59376229 8.25425,6.15294007 7.86425,6.49691378 C7.47325,6.84176948 6.84025,6.84176948 6.44925,6.49691378 L0.79325,1.50664897 Z"
                                            id="Fill-1"></path>
                                        <path
                                            d="M13.5635,1.50931564 C13.9535,1.16445994 13.9535,0.606164139 13.5635,0.26130844 C13.1725,-0.0835472579 12.5395,-0.0835472579 12.1485,0.26130844 L6.4925,5.25157325 C6.1025,5.59642895 6.1025,6.15560673 6.4925,6.49958045 C6.8835,6.84443615 7.5165,6.84443615 7.9075,6.49958045 L13.5635,1.50931564 Z"
                                            id="Fill-4"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>);
};
